import { render, staticRenderFns } from "./CurrentSectionTeacher.vue?vue&type=template&id=5588dd77&scoped=true"
import script from "./CurrentSectionTeacher.vue?vue&type=script&lang=js"
export * from "./CurrentSectionTeacher.vue?vue&type=script&lang=js"
import style0 from "./CurrentSectionTeacher.vue?vue&type=style&index=0&id=5588dd77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5588dd77",
  null
  
)

export default component.exports